module.exports = __webpack_public_path__ + "img/英国.cfba9dd7.jpg";